import { FC, Suspense, useEffect, useRef, useState } from 'react'
import { Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { MasterLayout } from '../../marketConnect/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { DashboardNewWrapper } from '../pages/dashboard/DashboardNewWrapper'
import { getCSSVariableValue } from '../../marketConnect/assets/ts/_utils'
import { toAbsoluteUrl, WithChildren } from '../../marketConnect/helpers'
import ConnectedPlatforms from '../pages/listing/ConnectedPlatforms'
import Platforms from 'src/app/pages/listing/Platforms'
import TemplateAndPricingQuickListLegacy from 'src/app/pages/template-and-pricing/TemplateAndPricingQuickListLegacy'
import ListingProfilesPreviousPage from 'src/app/pages/template-and-pricing/listing-profiles-previous/ListingProfilesPreviousPage'
import { ListingProfilesRolloutRoute } from 'src/app/pages/template-and-pricing/listing-profiles-new-ui-rollout'
import AllProducts from '../pages/products/AllProducts'
import Orders from '../pages/orders/Orders'
import OmsOrders from '../pages/orders/OmsOrders'
import Inventory from '../pages/inventory/Inventory'
import ProductsTable from '../pages/listing/components/listing-products/ProductsTable'
import OrderDetails from '../pages/orders/OrderDetails'
import AccountSetting from '../pages/AccountSetting'
import AccountSettingsModern from '../pages/account-settings/AccountSettingsModern'
import ProductDetailRoute from '../pages/product-detail/ProductDetailRoute'
import UserInvites from '../pages/user-invite/UserInvites'
import CreateProduct from '../pages/create-product/CreateProduct'
import UpdateProduct from '../pages/update-Product/UpdateProduct'
import ProductVariantDetail from '../pages/product-detail/productVariantDetail'
import ManageCustomers from '../pages/admin-panel/ManageCustomers'
import Report from '../pages/admin-panel/Report'
import ManageCustomerscopy from '../pages/admin-panel/ManageCustomerscopy'
import { useAppDispatch, useAppSelector } from 'src/redux/storeHooks'
import CommerciumLoader from 'src/utils/CommerciumLoader'
import { SuperAdminRoutes } from './SuperAdminRoutes'
import { fetchUserAccountDetailsAsync } from 'src/redux/actions/accountActions'
import { accessSessionTokenKeyName, loggedInAdminAccessToken } from 'src/utils/constants'
import {
  consumeImpersonationReturnPath,
  isAdminProfileDuringImpersonation,
  isImpersonationSessionActive,
  notifyImpersonationSessionChanged,
  peekImpersonationReturnPath,
  restoreCustomerSessionTokensIfNeeded,
} from 'src/utils/impersonationTokens'
import {logoutIfImpersonationAdminExpired} from 'src/utils/sessionExpiredLogout'
import CSVDownload from '../pages/download/CSVDownload'
import Vendors from '../pages/vendor/Vendors'
import AddUpdateVendorData from '../pages/vendor/AddUpdateVendorData'
import DynamicPlatformSetting from '../pages/listing/DynamicPlatformSetting'
import Pricing from '../pages/pricing-page/Pricing'
import Dashboard from '../pages/dashboard/Dashboard'
import FeatureRequest from '../pages/feature-request/FeatureRequest'
import Invoices from '../pages/invoice/Invoices'
import TourPopup from '../pages/dashboard-tour/TourPopup'
import TourPopupOms from '../pages/dashboard-tour/TourPopupOms'
import BillingPlanDetail from '../pages/BillingPlanDetail'
import OrderAcknowledgements from '../pages/orders/OrderAcknowledgements'
import { getUserPlanAsync } from 'src/redux/actions/pricingActions'
import { fetchConnectedPlatformAsync, fetchPlatformsAsync } from 'src/redux/actions/platformActions'
import CancellationLogs from '../pages/orders/CancellationLogs'
import clsx from 'clsx'
import { HeaderUserMenu } from 'src/marketConnect/partials'
import RefundLogs from '../pages/orders/RefundLogs'
import InvoiceLogs from '../pages/orders/InvoiceLogs'
import Onboard from '../pages/new-onboard-process/Onboard'
import {BillingPlanAndUsageRoute} from '../pages/pricing-page/PlanAndUsagePage'
import UpdatedPricingPageV2 from '../pages/pricing-page/UpdatedPricingPageV2'
import AvailablePlatformSetting from '../pages/listing/AvailablePlatformSetting'
import Support from '../pages/support/component/Support'
import TransactionSummary from '../pages/invoice/TransactionSummary'
import Invoice from '../pages/invoice/InvoicePage'
import PhoneNumberPopUp from '../pages/dashboard-tour/PhoneNumberPopUp'
import ChannelsIntegration from '../pages/listing/ChannelsIntegration'
import DynamicPlatformSettingWrapper from '../pages/listing/DynamicPlatformSettingWrapper'
import AdvancedChannelSettingsWrapper from '../features/advanced-channel-settings/pages/AdvancedChannelSettingsWrapper'
import InventoryLogs from '../pages/inventory/InventoryLogs'
import PriceLogs from '../pages/price-logs/PriceLogs'
import HistoryLogs from '../pages/history-logs/HistoryLogs'
import useAppToast from 'src/hooks/useAppToast'
import {
  finalizeTikTokInstallationIfNeeded,
  getPendingPlatformInstallationName,
  hasPendingPlatformInstallation,
} from 'src/utils/tiktokFinalizer'
import InvoiceDetailsGeneration from '../pages/pricing-page/InvoiceDetails'
import ActiveBundleDefinitions from '../pages/active-bundle-definition/ActiveBundle'
import RuleBuilder from '../pages/rule-engine/CreateEditRule'
import RuleListing from '../pages/rule-engine/ListingRuleEngine'
import AddManageUserFunctionality from '../pages/admin-panel/AddManageUserFunctionality'
import ManageRolesFunctionality from '../pages/admin-panel/ManageRolesFunctionality'
import { getMenuList } from 'src/redux/actions/manageUserActions'
import NewHistoryLogs from '../pages/history-logs/NewHistoryLogs'
import { ListingProductTableLitePage } from '../features/listing-product-table-lite'
import { ProductsTableV2 } from '../features/listing-product-table-v2'
import { PayoutLogDetailPage, PayoutLogsPage } from '../features/payout-logs'
import WarehouseListing from '../pages/warehouse-location/WarehouseListing'
import InventoryAdjustmentListing from '../pages/inventory-adjustment/InventoryAdjustmentListing'
import InventoryTransferListing from '../pages/inventory-transfer/InventoryTransferListing'
import CustomFieldsListing from '../pages/custom-fields/CustomFieldsListing'
import OldCreateProduct from '../pages/create-product/old-CreateProduct'
import EditMoreExpandVariantSection from '../pages/create-product/EditMoreExpandVariants'
import { TermsAcceptanceGate } from '../modules/auth/components/TermsAcceptanceGate'
import CategoryManagePage from '../pages/category-manage/CategoryManagePage'
import CreateOmsOrder from '../pages/oms-create-order/CreateOmsOrder'
import EditOmsOrder from '../pages/oms-edit-order/EditOmsOrder'


// import CreateProduct from '../pages/create-product/createProduct' 


const PrivateRoutes = () => {
  restoreCustomerSessionTokensIfNeeded()

  const [isPhoneNumberStepDoneState, setIsPhoneNumberStepDoneState] = useState(false);
  const { fetchedUserAccountData, fetchedUserStaffData } = useAppSelector(state => state.userAccountData)
  const { omsStoreData } = useAppSelector(state => state.fetchConnectedPlatform)
  const { visible } = useAppSelector(state => state.tourPopup)
  const { isLoggedIn, userDetail } = useAppSelector(state => state.auth)
  const location = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const userAvatarClass = 'symbol-35px'
  const itemClass = 'ms-1 ms-md-4'
  const dispatch = useAppDispatch()
  const { errorToast } = useAppToast()
  const isSuperUser =
    fetchedUserAccountData?.is_superuser ||
    fetchedUserAccountData?.account_type === 'SUPERADMIN';

  const accountType = fetchedUserAccountData?.account_type;
  const isUserStaff = fetchedUserAccountData?.parent_user_role;
  const parentUserRole = fetchedUserAccountData?.parent_user_role;
  const hasFetchedAdminRole = useRef(false)
  const isAdminStaff = fetchedUserStaffData?.account_type === "ADMIN_STAFF";
  const shouldShowPhoneNumberPopup =
    fetchedUserAccountData?.user_type === 'USER' &&
    fetchedUserAccountData.isPhoneNumberStepDone === false
  const shouldShowTourPopup =
    fetchedUserAccountData?.user_type === 'USER' &&
    fetchedUserAccountData.isPhoneNumberStepDone === true &&
    !fetchedUserAccountData.isOnboardingProcessCompleted
  const isForceOmsChoiceFromParam = ['1', 'true', 'yes'].includes(
    (new URLSearchParams(location.search).get('showOmsChoice') || '').toLowerCase()
  )
  const isTourV2FromParam = ['1', 'true', 'yes'].includes(
    (new URLSearchParams(location.search).get('tourV2') || '').toLowerCase()
  )
  const hasSeenOmsChoiceModal =
    Boolean(fetchedUserAccountData?.id) &&
    sessionStorage.getItem(`onboarding_oms_choice_seen_${fetchedUserAccountData?.id}`) === 'true'
  const shouldUseOmsTourPopup =
    isTourV2FromParam || (isForceOmsChoiceFromParam && !hasSeenOmsChoiceModal)

  const isRouteRestricted = (key: string) => {
    return isUserStaff && accountType === 'DIRECT' && parentUserRole[key] === 'RESTRICT';
  };
  const isDashboardRestricted = () => {
    return isUserStaff && accountType === 'DIRECT' && parentUserRole['other_access'] === 'RESTRICT';
  };
  const canAccessApplicationLogs =
    fetchedUserAccountData?.account_type === 'DIRECT' &&
    (
      fetchedUserStaffData?.account_type === 'ADMIN_STAFF' ||
      fetchedUserStaffData?.is_superuser === true
    );

  /**
   * Guard for routes exclusive to OMS (warehouse, inventory, custom-fields, categories, create-product)
   */
  const isOmsRouteAccessible = (): boolean => {
    return fetchedUserAccountData?.userAdditionalInfo?.platform_connection_priority === 'OMS';
  };

  /** True when the account has a connected Commercium OMS platform (isOmsStore). */
  const hasOmsConnectedPlatform = (): boolean => Boolean(omsStoreData);

  const renderOrdersAllRoute = () => (hasOmsConnectedPlatform() ? <OmsOrders /> : <Orders />);

  /** Temporary route:*/
  const renderOldOrdersAllRoute = () =>
    hasOmsConnectedPlatform() ? <Orders /> : <Navigate to='/orders-all' replace />;

  const impersonatingCustomer = isImpersonationSessionActive()
  const useCustomerRouteTree =
    impersonatingCustomer ||
    (fetchedUserAccountData?.account_type === 'DIRECT' && !isUserStaff) ||
    fetchedUserAccountData === null

  useEffect(() => {
    logoutIfImpersonationAdminExpired(dispatch)

    const intervalId = window.setInterval(() => {
      logoutIfImpersonationAdminExpired(dispatch)
    }, 30_000)

    return () => window.clearInterval(intervalId)
  }, [dispatch])

  useEffect(() => {
    restoreCustomerSessionTokensIfNeeded()

    if (isLoggedIn) {
      setLoading(true)
      Promise.all([
        dispatch(fetchUserAccountDetailsAsync()),
        dispatch(getUserPlanAsync()),
      ])
        .finally(() => {
          dispatch(fetchPlatformsAsync())
          dispatch(fetchConnectedPlatformAsync())
          setLoading(false)
        })
    } else {
      dispatch(fetchUserAccountDetailsAsync()).then().catch()
    }
  }, [isLoggedIn, localStorage.getItem(accessSessionTokenKeyName), isPhoneNumberStepDoneState])

  useEffect(() => {
    if(fetchedUserAccountData === null){
      return
    }
    if ((!isSuperUser && accountType !== 'SUPERADMIN') && accountType !== "USER_STAFF" && accountType !== "ADMIN_STAFF") {
      const menuListResponse = dispatch(getMenuList());
    }
  }, [fetchedUserAccountData])

  useEffect(() => {
    if (parentUserRole && !hasFetchedAdminRole.current) {
      hasFetchedAdminRole.current = true
      dispatch(fetchUserAccountDetailsAsync({ useAdminToken: true }))
    }
  }, [parentUserRole, dispatch])

  useEffect(() => {
    if (!isImpersonationSessionActive()) return
    const restored = restoreCustomerSessionTokensIfNeeded()
    if (restored || isAdminProfileDuringImpersonation(fetchedUserAccountData)) {
      dispatch(fetchUserAccountDetailsAsync()).finally(() => {
        notifyImpersonationSessionChanged()
      })
    }
  }, [])

  useEffect(() => {
    if (!isImpersonationSessionActive()) return
    if (isAdminProfileDuringImpersonation(fetchedUserAccountData)) {
      dispatch(fetchUserAccountDetailsAsync())
    }
  }, [
    fetchedUserAccountData?.id,
    fetchedUserAccountData?.account_type,
    fetchedUserAccountData?.parent_user_role,
    dispatch,
  ])

  useEffect(() => {
    const recoverImpersonationAfterBack = (event: PageTransitionEvent) => {
      const shouldRecover =
        isImpersonationSessionActive() || Boolean(peekImpersonationReturnPath())
      if (!shouldRecover) return

      restoreCustomerSessionTokensIfNeeded()
      dispatch(fetchUserAccountDetailsAsync()).then(() => {
        notifyImpersonationSessionChanged()
        if (!event.persisted) return
        const returnPath = consumeImpersonationReturnPath()
        if (returnPath) {
          navigate(returnPath, { replace: true })
          return
        }
        navigate(`${location.pathname}${location.search}`, { replace: true })
      })
    }

    window.addEventListener('pageshow', recoverImpersonationAfterBack)
    return () => window.removeEventListener('pageshow', recoverImpersonationAfterBack)
  }, [dispatch, navigate, location.pathname, location.search])

  useEffect(() => {
    if (!fetchedUserAccountData?.id) {
      return 
    }
    if (!hasPendingPlatformInstallation()) {
      return
    }

    ; (async () => {
      try {
        const didFinalize = await finalizeTikTokInstallationIfNeeded(dispatch, fetchedUserAccountData)
        if (didFinalize) {
          dispatch(fetchConnectedPlatformAsync())
          dispatch(fetchUserAccountDetailsAsync())
        }
      } catch (error) {
        const pendingPlatformName = getPendingPlatformInstallationName() || 'platform'
        errorToast(`Unable to finalize ${pendingPlatformName} installation. Please try again.`) 
      }
    })()
  }, [dispatch, errorToast, fetchedUserAccountData])

  if (loading) return <CommerciumLoader />

  return (
    <TermsAcceptanceGate>
    <>
      {
        shouldShowPhoneNumberPopup ?
          <>
            {/* <div style={{position:'fixed', top:'2.6%', right:'0%', zIndex:9999, display:'flex', cursor:'pointer', paddingRight:'30px' }} >
        <div className={clsx('app-navbar-item', itemClass)}>
          <div
            className={clsx('cursor-pointer symbol border border-2 rounded-circle p-2', userAvatarClass, visible ? 'bg-secondary' : ''  )}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent' 
            data-kt-menu-placement='bottom-end'
          >
            <img src={toAbsoluteUrl('/media/avatars/man_5-1024.webp')} alt='' />
          </div>
          <HeaderUserMenu />
        </div>
      </div> */}   
            {/* <TourPopup/>  */}
            <PhoneNumberPopUp setIsPhoneNumberStepDoneState={setIsPhoneNumberStepDoneState} />
          </>
          : null
      }
      {
        shouldShowTourPopup ?
          <>
            <div style={{ position: 'fixed', top: '1.8%', right: '0%', zIndex: 9999, display: 'flex', cursor: 'pointer', paddingRight: '22px' }} >
              <div className={clsx('app-navbar-item', itemClass)}>
                <div
                  className={clsx('cursor-pointer symbol border border-2 rounded-circle p-2', userAvatarClass, visible ? 'bg-secondary' : '')}
                  data-kt-menu-trigger="{default: 'click'}"
                  data-kt-menu-attach='parent'
                  data-kt-menu-placement='bottom-end'
                >
                  <img src={toAbsoluteUrl('/media/avatars/man_5-1024.webp')} alt='' />
                </div>
                <HeaderUserMenu />
              </div>
            </div>
            {shouldUseOmsTourPopup ? <TourPopupOms /> : <TourPopup />}
          </>
          : null
      }
      <Routes>
        {useCustomerRouteTree ?
          <Route element={<MasterLayout />}>
            {
              fetchedUserAccountData?.id ?
                fetchedUserAccountData?.is_subscribed && fetchedUserAccountData.isOnboardingProcessCompleted ?
                  <Route path='/*' element={<Navigate to='/dashboard' />} /> :
                  <Route path='/*' element={<Navigate to='/pricing' />} />
                : <Route path='/*' element={<Navigate to='/dashboard' />} />
            }
            {fetchedUserAccountData?.id ?
              fetchedUserAccountData?.is_subscribed && fetchedUserAccountData.isOnboardingProcessCompleted ?
                <Route path='auth/*' element={<Navigate to='/dashboard' />} /> :
                <Route path='auth/*' element={<Navigate to='/pricing' />} />
              : <Route path='auth/*' element={<Navigate to='/dashboard' />} />
            }

            <Route path='dashboard' element={<DashboardNewWrapper />} />
            {/* Safe fallback redirect for anyone who bookmarked dashboard-new */}
            <Route path='dashboard-new' element={<Navigate to='/dashboard' replace />} />
            <Route path='test-dashboard' element={<Dashboard />} />
            <Route path='/platforms' element={<ChannelsIntegration />} />
            <Route path='/listing-channels' element={<ChannelsIntegration />} />
            <Route path='/listing-channels/:selectedPlatformId' element={<ChannelsIntegration />} />
            <Route path='/support' element={<Support />} />
            <Route path='/transaction-summary' element={<TransactionSummary />} />
            <Route path='/invoice' element={<Invoice />} />


            {/* <Route path='/platform-setting/:selectedPlatformId' element={<PlatformSetting />} /> */}
            {/* <Route path='/primary-platform-setting/:selectedPlatformId' element={<PrimaryPlatformSetting />} /> */}
            <Route path='/listing-profiles' element={<ListingProfilesRolloutRoute />} />
            <Route path='/listing-profiles-old' element={<TemplateAndPricingQuickListLegacy />} />
            <Route path='/listing-profiles-previous' element={<ListingProfilesPreviousPage />} />
            <Route path='/template-and-pricing' element={<Navigate to='/listing-profiles' replace />} />
            <Route path='/products-all' element={<AllProducts />} />
            <Route path='/orders-all' element={renderOrdersAllRoute()} />
            <Route path='/old-orders-all' element={renderOldOrdersAllRoute()} />
            <Route path='/oms-orders-all' element={<Navigate to='/orders-all' replace />} />
            <Route path='/oms/create-order' element={<CreateOmsOrder />} />
            <Route path='/update-order/orderId/:orderId' element={<EditOmsOrder />} />
            <Route path='/inventory-all' element={<Inventory />} />
            <Route path='/inventory-logs' element={<InventoryLogs />} />
            <Route path='/price-logs' element={<PriceLogs />} />
            <Route path='/listing-product-table-new/:platformId/:id' element={<ProductsTable />} />
            <Route path='/listing-product-table/:platformId/:id' element={<ProductsTableV2 />} />
            <Route path='/listing-product-table-old/:platformId/:id' element={<ListingProductTableLitePage />} />
            <Route path='/listing-product-table-ag/:platformId/:id' element={<ListingProductTableLitePage />} />
            <Route path='/payout-logs' element={<PayoutLogsPage />} />
            <Route path='/payout-logs/:platformId/:id' element={<PayoutLogsPage />} />
            <Route path='/payout-logs/:platformId/:id/:payoutDate' element={<PayoutLogDetailPage />} />
            <Route path='/sales/details/:orderId' element={<OrderDetails />} />
            <Route path='/product-variant-detail/:variantId/platform/:platformId/product/:productId/:availablePlatformId' element={<ProductDetailRoute />} />
            <Route path='/product-linked-variant-detail/:variantId/platform/:platformId/product/:productVariantId' element={<ProductVariantDetail />} />
            <Route path='/account/settings' element={<AccountSettingsModern />} />
            <Route path='/settings-old' element={<AccountSetting />} />
            {/* <Route path='/user-invite' element={<UserInvites/>}/> */}
            <Route path='/manage-categories/:platformId' element={isOmsRouteAccessible() ? <CategoryManagePage /> : <Navigate to='/dashboard' replace />} />
            <Route path='/create-product' element={isOmsRouteAccessible() ? <OldCreateProduct /> : <Navigate to='/dashboard' replace />} />
            <Route path='/update-product/platform/:platformId/productId/:productId' element={<OldCreateProduct />} />
            <Route path='/variant-create' element={<EditMoreExpandVariantSection />} />
            <Route path='/variant-create/platform/:platformId/productId/:productId' element={<EditMoreExpandVariantSection />} />
            <Route path='/update-variant/platform/:platformId/productId/:productId/variantId/:variantId' element={<EditMoreExpandVariantSection />} />
            <Route path='/update-product' element={<UpdateProduct />} />
            <Route path='/manage-customers' element={<ManageCustomers />} />
            <Route path='/manage-customers-copy' element={<ManageCustomerscopy />} />
            <Route path='/admin-reports' element={<Report />} />
            <Route path='/products-files' element={<CSVDownload />} />
            <Route path='/vendors' element={<Vendors />} />
            <Route path='/edit-vendor/:vendorId' element={<AddUpdateVendorData />} />
            <Route path='/platform-setting-new/:availablePlatformId/:selectedPlatformId' element={<DynamicPlatformSetting />} />
            <Route path='/platform-setting-beta/:availablePlatformId/:selectedPlatformId' element={<DynamicPlatformSettingWrapper />} />
            <Route path='/channel-settings/:availablePlatformId/:selectedPlatformId' element={<AdvancedChannelSettingsWrapper />} />
            <Route path='/channel-settings-legacy/:availablePlatformId/:selectedPlatformId' element={<DynamicPlatformSettingWrapper />} />
            <Route path='/pricing' element={<BillingPlanAndUsageRoute />} />
            <Route path='/pricing/classic' element={<UpdatedPricingPageV2 />} />
            <Route path='/pricing/:platformId' element={<BillingPlanAndUsageRoute />} />
            <Route path='/feature-request' element={<FeatureRequest />} />
            <Route path='/invoice-all' element={<InvoiceLogs />} />
            <Route path='/billing-detail' element={<BillingPlanDetail activePlanDetail={null} isOldPrice={null} />} />
            <Route path='/order-acknowledges' element={<OrderAcknowledgements />} />
            <Route path='/order-cancellation' element={<CancellationLogs />} />
            <Route path='/order-refund' element={<RefundLogs />} />
            <Route path='/new-onboard' element={<Onboard />} />
            <Route path='/available-platform-setting/:availablePlatformId' element={<AvailablePlatformSetting />} />
            <Route path='/support' element={<Support />} />
            <Route path='/history/logs' element={<HistoryLogs />} />
            <Route path='/invoices' element={<InvoiceDetailsGeneration />} />
            <Route path='/bundles' element={<ActiveBundleDefinitions />} />
            <Route path='/rule-engine' element={<RuleListing />} />
            <Route path='/rule-builder/create-edit' element={<RuleBuilder />} />
            <Route path='/warehouse-listing' element={isOmsRouteAccessible() ? <WarehouseListing /> : <Navigate to='/dashboard' replace />} />
            <Route path='/inventory-adjustment' element={isOmsRouteAccessible() ? <InventoryAdjustmentListing /> : <Navigate to='/dashboard' replace />} />
            <Route path='/inventory-transfer' element={isOmsRouteAccessible() ? <InventoryTransferListing /> : <Navigate to='/dashboard' replace />} />
            <Route path='/custom-fields' element={isOmsRouteAccessible() ? <CustomFieldsListing /> : <Navigate to='/dashboard' replace />} />

            <Route path='/manage-user-roles' element={<AddManageUserFunctionality />} />
            { }
            <Route
              path="/application-logs"
              element={
                // Only allow access if:
                // 1. user account is DIRECT
                // 2. fetchedUserStaffData exists
                // 3. staff is ADMIN_STAFF or superuser
                ( fetchedUserStaffData?.account_type === "ADMIN_STAFF" && fetchedUserAccountData?.account_type ==="DIRECT") || 
               (localStorage.getItem(loggedInAdminAccessToken) && fetchedUserAccountData?.account_type ==="DIRECT") 
                  ? <NewHistoryLogs />
                  : <Navigate to="/account/settings" replace />
              }
            />

            {/* Page Not Found */}
            <Route path='*' element={<Navigate to='/error/404' />} />
          </Route> :
          <Route element={<MasterLayout />}>
            <Route path='/*' element={<SuperAdminRoutes />} />
          </Route>
        }

        {/* USER_STAFF + DIRECT conditional routes */}
        {(isUserStaff && parentUserRole && accountType === 'DIRECT') && (
          <Route element={<MasterLayout />}>

            {/* DASHBOARD & OTHER */}
            <Route path="/dashboard" element={isDashboardRestricted() ? <Navigate to="/account/settings" replace /> : <DashboardNewWrapper />} />
            <Route path="/dashboard-new" element={<Navigate to="/dashboard" replace />} />
            <Route path="/rule-engine" element={isDashboardRestricted() ? <Navigate to="/account/settings" replace /> : <RuleListing />} />
            <Route path="/rule-builder/create-edit" element={isDashboardRestricted() ? <Navigate to="/account/settings" replace /> : <RuleBuilder />} />


            {/* PRODUCT */}
            <Route path="/manage-categories/:platformId" element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : !isOmsRouteAccessible() ? <Navigate to='/dashboard' replace /> : <CategoryManagePage />} />
            <Route path="/products-all" element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <AllProducts />} />
            <Route path="/create-product" element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : !isOmsRouteAccessible() ? <Navigate to='/dashboard' replace /> : <OldCreateProduct />} />
            <Route path="/update-product" element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <UpdateProduct />} />
            <Route path='/update-product/platform/:platformId/productId/:productId' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <OldCreateProduct />} />
            <Route path='/variant-create' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <EditMoreExpandVariantSection />} />
            <Route path='/variant-create/platform/:platformId/productId/:productId' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <EditMoreExpandVariantSection />} />
            <Route path='/update-variant/platform/:platformId/productId/:productId/variantId/:variantId' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <EditMoreExpandVariantSection />} />
            <Route path='/listing-product-table-new/:platformId/:id' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <ProductsTable />} />
            <Route path='/listing-product-table/:platformId/:id' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <ProductsTableV2 />} />
            <Route path='/listing-product-table-old/:platformId/:id' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <ListingProductTableLitePage />} />
            <Route path='/listing-product-table-ag/:platformId/:id' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <ListingProductTableLitePage />} />
            <Route path='/listing-profiles' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <ListingProfilesRolloutRoute />} />
            <Route path='/listing-profiles-old' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <TemplateAndPricingQuickListLegacy />} />
            <Route path='/listing-profiles-previous' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <ListingProfilesPreviousPage />} />
            <Route path='/template-and-pricing' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <Navigate to='/listing-profiles' replace />} />
            <Route path="/inventory-logs" element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <InventoryLogs />} />
            <Route path='/price-logs' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <PriceLogs />} />
            <Route path='/bundles' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <ActiveBundleDefinitions />} />
            <Route path='/product-variant-detail/:variantId/platform/:platformId/product/:productId/:availablePlatformId' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <ProductDetailRoute />} />
            <Route path='/product-linked-variant-detail/:variantId/platform/:platformId/product/:productVariantId' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : <ProductVariantDetail />} />
            <Route path='/warehouse-listing' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : !isOmsRouteAccessible() ? <Navigate to='/dashboard' replace /> : <WarehouseListing />} />
            <Route path='/inventory-adjustment' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : !isOmsRouteAccessible() ? <Navigate to='/dashboard' replace /> : <InventoryAdjustmentListing />} />
            <Route path='/inventory-transfer' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : !isOmsRouteAccessible() ? <Navigate to='/dashboard' replace /> : <InventoryTransferListing />} />
            <Route path='/custom-fields' element={isRouteRestricted('product_access') ? <Navigate to="/account/settings" replace /> : !isOmsRouteAccessible() ? <Navigate to='/dashboard' replace /> : <CustomFieldsListing />} />


            {/* SALES */}
            <Route path="/orders-all" element={isRouteRestricted('sales_access') ? <Navigate to="/account/settings" replace /> : renderOrdersAllRoute()} />
            <Route path="/old-orders-all" element={isRouteRestricted('sales_access') ? <Navigate to="/account/settings" replace /> : renderOldOrdersAllRoute()} />
            <Route path="/oms-orders-all" element={<Navigate to="/orders-all" replace />} />
            <Route path="/sales/details/:orderId" element={isRouteRestricted('sales_access') ? <Navigate to="/account/settings" replace /> : <OrderDetails />} />
            <Route path='/payout-logs' element={isRouteRestricted('sales_access') ? <Navigate to="/account/settings" replace /> : <PayoutLogsPage />} />
            <Route path='/payout-logs/:platformId/:id' element={isRouteRestricted('sales_access') ? <Navigate to="/account/settings" replace /> : <PayoutLogsPage />} />
            <Route path='/payout-logs/:platformId/:id/:payoutDate' element={isRouteRestricted('sales_access') ? <Navigate to="/account/settings" replace /> : <PayoutLogDetailPage />} />

            {/* CUSTOMER */}
            <Route path="/manage-customers" element={isRouteRestricted('customer_access') ? <Navigate to="/account/settings" replace /> : <ManageCustomers />} />

            {/* INVENTORY */}
            <Route path="/inventory-all" element={isRouteRestricted('inventory_access') ? <Navigate to="/account/settings" replace /> : <Inventory />} />

            {/* INTEGRATION */}
            <Route path="/platforms" element={isRouteRestricted('integration_access') ? <Navigate to="/account/settings" replace /> : <ChannelsIntegration />} />
            <Route path="/listing-channels" element={isRouteRestricted('integration_access') ? <Navigate to="/account/settings" replace /> : <ChannelsIntegration />} />
            <Route path="/listing-channels/:selectedPlatformId" element={isRouteRestricted('integration_access') ? <Navigate to="/account/settings" replace /> : <ChannelsIntegration />} />
            {/* <Route path="/platform-setting/:selectedPlatformId" element={isRouteRestricted('integration_access') ? <Navigate to="/account/settings" replace /> : <PlatformSetting />} /> */}
            <Route path="/platform-setting-new/:availablePlatformId/:selectedPlatformId" element={isRouteRestricted('integration_access') ? <Navigate to="/account/settings" replace /> : <DynamicPlatformSetting />} />
            <Route path="/platform-setting-beta/:availablePlatformId/:selectedPlatformId" element={isRouteRestricted('integration_access') ? <Navigate to="/account/settings" replace /> : <DynamicPlatformSettingWrapper />} />
            <Route path="/channel-settings/:availablePlatformId/:selectedPlatformId" element={isRouteRestricted('integration_access') ? <Navigate to="/account/settings" replace /> : <AdvancedChannelSettingsWrapper />} />
            <Route path="/channel-settings-legacy/:availablePlatformId/:selectedPlatformId" element={isRouteRestricted('integration_access') ? <Navigate to="/account/settings" replace /> : <DynamicPlatformSettingWrapper />} />
            {/* <Route path="/primary-platform-setting/:selectedPlatformId" element={isRouteRestricted('integration_access') ? <Navigate to="/account/settings" replace /> : <PrimaryPlatformSetting />} /> */}

            {/* BILLING */}
            <Route path="/transaction-summary" element={isRouteRestricted('billing_access') ? <Navigate to="/account/settings" replace /> : <TransactionSummary />} />
            <Route path="/invoice" element={isRouteRestricted('billing_access') ? <Navigate to="/account/settings" replace /> : <Invoice />} />
            <Route path="/pricing" element={isRouteRestricted('billing_access') ? <Navigate to="/account/settings" replace /> : <BillingPlanAndUsageRoute />} />
            <Route path="/pricing/classic" element={isRouteRestricted('billing_access') ? <Navigate to="/account/settings" replace /> : <UpdatedPricingPageV2 />} />
            <Route path="/pricing/:platformId" element={isRouteRestricted('billing_access') ? <Navigate to="/account/settings" replace /> : <BillingPlanAndUsageRoute />} />
            <Route path="/billing-detail" element={isRouteRestricted('billing_access') ? <Navigate to="/account/settings" replace /> : <BillingPlanDetail activePlanDetail={null} isOldPrice={null} />} />

            {/* USER / ROLE MANAGEMENT */}
            <Route path="/manage-user-roles" element={isRouteRestricted('user_staff_management_access') ? <Navigate to="/account/settings" replace /> : <AddManageUserFunctionality />} />
            {/* <Route path="/manage-roles" element={isRouteRestricted('user_staff_management_access') ? <Navigate to="/account/settings" replace /> : <ManageRolesFunctionality />} /> */}

            {/* OPEN */}
            <Route
              path="/application-logs"
              element={
                // Only allow access if:
                // 1. user account is DIRECT
                // 2. fetchedUserStaffData exists
                // 3. staff is ADMIN_STAFF or superuser
               ( fetchedUserStaffData?.account_type === "ADMIN_STAFF" && fetchedUserAccountData?.account_type ==="DIRECT") || 
               (localStorage.getItem(loggedInAdminAccessToken) && fetchedUserAccountData?.account_type ==="DIRECT") 
                  ? <NewHistoryLogs />
                  : <Navigate to="/account/settings" replace />
              }
            />

            <Route path="/account/settings" element={<AccountSettingsModern />} />
            <Route path="/settings-old" element={<AccountSetting />} />
            <Route path='/support' element={<Support />} />

            { }
            <Route path="*" element={<Navigate to={isDashboardRestricted() ? "/account/settings" : "/dashboard"} replace />} />

          </Route>
        )}

      </Routes>
    </>
      </TermsAcceptanceGate>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
